import Vue from 'vue/dist/vue.esm'
import VueRouter from 'vue-router';
import createRouter from 'routers/fragrance-finder-router'

export default function buildFragranceFinderApp(element) {
  Vue.use(VueRouter);

  const router = createRouter();

  new Vue({
    el: element,
    template: '<router-view />',
    router
  })
}
